import { LEAVE_TYPE_LABELS } from '@aegislab/shared';

export const INTENSITY_THRESHOLDS = [2, 4, 6, 8] as const;

export function getIntensityLevel(hours: number): 0 | 1 | 2 | 3 | 4 {
  if (hours <= 0) return 0;
  if (hours < INTENSITY_THRESHOLDS[0]) return 1;
  if (hours < INTENSITY_THRESHOLDS[1]) return 2;
  if (hours < INTENSITY_THRESHOLDS[2]) return 3;
  return 4;
}

export const LEAVE_LABELS: Record<string, string> = LEAVE_TYPE_LABELS;
